/* global window:true */
import * as mobileAppHandler from '../utils/mobile-app';

import ViewManager from './view-manager';

/**
* Initialises the component and registers the instance
* with the AuthManager component
*
* @param {HTMLNode} rootElement The component dom node
*/
export default function(rootElement) {
  if (!rootElement) {
    return;
  }

  const viewInstance = new ViewManager(rootElement);

  // if the mobile app bridge is present, then we don't
  // want to register this instance with the authManager
  if (mobileAppHandler.isEnabled(rootElement)) {
    return;
  }

  if (viewInstance && window.sdc && window.sdc.authManager) {
    window.sdc.authManager.addView(viewInstance);
  }
}
